import React from 'react'
import TEXT from '../Text';
import { PercentInput } from '../FormFields';
import { identity } from "../../../utils/getIdentity";
import { useTranslation } from "react-i18next";

const SystemFeeSwap = ({ name }) => {
  const { t } = useTranslation();
  return (
    <div className={`system-fee-setting system-fee-setting-${identity}`}>
    <TEXT.sectionTitle>% {t('admin.fee_swap')}</TEXT.sectionTitle>
    <TEXT.sectionDescription className={`system-fee-switcher__description system-fee-switcher__description-${identity}`}>
      {t('admin.percent_comission')}
    </TEXT.sectionDescription>
    <PercentInput name={name} className="system-fee-setting__input" />
  </div>
  )
}

export default SystemFeeSwap